// Centralized nav link data — ordered by Ahrefs search volume
// Update this file to change what appears in header mega-menus and mobile nav

export const CUISINE_LINKS = [
  { name: 'Taco Trucks', url: '/taco-trucks', emoji: '\u{1F32E}' },
  { name: 'BBQ Food Trucks', url: '/bbq-food-trucks', emoji: '\u{1F356}' },
  { name: 'Pizza Food Trucks', url: '/pizza-food-trucks', emoji: '\u{1F355}' },
  { name: 'Dessert Food Trucks', url: '/dessert-food-trucks', emoji: '\u{1F366}' },
  { name: 'Breakfast Food Trucks', url: '/breakfast-food-trucks', emoji: '\u{1F95E}' },
  { name: 'Burger Food Trucks', url: '/burger-food-trucks', emoji: '\u{1F354}' },
  { name: 'Healthy Food Trucks', url: '/healthy-food-trucks', emoji: '\u{1F957}' },
  { name: 'Asian Food Trucks', url: '/asian-food-trucks', emoji: '\u{1F961}' },
  { name: 'Gyro Food Trucks', url: '/gyro-food-trucks', emoji: '\u{1F959}' },
  { name: 'Sandwich Food Trucks', url: '/sandwich-food-trucks', emoji: '\u{1F96A}' },
];

// Ordered by Ahrefs organic traffic (March 2026)
export const SEATTLE_LOCATIONS = [
  { name: "Saleh's", url: '/schedule/salehs' },                          // 369 traffic
  { name: 'Starbucks Center', url: '/schedule/starbucks-center' },        // 242 traffic
  { name: 'Westlake Park', url: '/schedule/westlake-park' },              // 166 traffic, 44 keywords
  { name: 'Black Raven Brewing', url: '/schedule/black-raven-brewing-company-woodinville' }, // 138 traffic
  { name: 'Broadview Tap House', url: '/schedule/broadview-tap-house' },  // 109 traffic
  { name: "Chuck's Hop Shop", url: '/schedule/chuck-s-hop-shop-greenwood' }, // 34 traffic
];

export const PORTLAND_LOCATIONS = [
  { name: 'Cartopia', url: '/schedule/cartopia-food-cart-pod' },
  { name: 'Pioneer Courthouse Square', url: '/schedule/pioneer-courthouse-square-food-cart-pod' },
  { name: 'Cartlandia', url: '/schedule/cartlandia-food-cart-pod' },
  { name: 'Hawthorne Asylum', url: '/schedule/hawthorne-asylum' },
  { name: 'Portland Mercado', url: '/schedule/portland-mercado' },
  { name: 'Prost Marketplace', url: '/schedule/prost-marketplace' },
];

// Ordered by Ahrefs organic traffic (March 2026)
export const SEATTLE_TRUCKS = [
  { name: 'Birrieria Pepe El Toro', url: '/food-trucks/birrieria-pepe-el-toro' }, // 513 traffic
  { name: 'Lunch On The Plate', url: '/food-trucks/lunch-on-the-plate' },         // 306 traffic
  { name: 'Impeckable Chicken', url: '/food-trucks/impeckable-chicken' },          // 275 traffic
  { name: 'Momo Express', url: '/food-trucks/momo-express' },                     // 173 traffic
  { name: 'Off The Rez', url: '/food-trucks/off-the-rez' },                       // 158 traffic
  { name: 'Gogi On The Go', url: '/food-trucks/gogi-on-the-go' },                 // 139 traffic
];

export const PORTLAND_TRUCKS = [
  { name: "Matt's BBQ", url: '/food-trucks/matt-s-bbq' },
  { name: 'Jojo Food Cart', url: '/food-trucks/jojo-food-cart' },
  { name: 'Pyro Pizza', url: '/food-trucks/pyro-pizza' },
  { name: 'Chicken and Guns', url: '/food-trucks/chicken-and-guns' },
  { name: 'Kim Jong Grillin', url: '/food-trucks/kim-jong-grillin' },
  { name: 'Koi Fusion', url: '/food-trucks/koi-fusion' },
];

// Ordered by search volume + traffic potential
export const CATERING_EVENT_LINKS = [
  { name: 'Events & Festivals', url: '/food-truck-catering/community-events' },
  { name: 'Corporate Catering', url: '/food-truck-catering/corporate-catering' },
  { name: 'Wedding Catering', url: '/food-truck-catering/wedding-catering' },
  { name: 'Private Parties', url: '/food-truck-catering/private-parties' },
  { name: 'Birthday Parties', url: '/food-truck-catering/birthday-parties' },
  { name: 'Office Lunch', url: '/food-truck-catering/office-lunch' },
  { name: 'Fundraisers', url: '/food-truck-catering/fundraiser' },
  { name: 'Special Occasions', url: '/food-truck-catering/special-occasions' },
];

// Ordered by search volume
export const CATERING_CUISINE_LINKS = [
  { name: 'Taco Catering', url: '/food-truck-catering/taco-catering', emoji: '\u{1F32E}' },
  { name: 'Pizza Catering', url: '/food-truck-catering/pizza-catering', emoji: '\u{1F355}' },
  { name: 'BBQ Catering', url: '/food-truck-catering/bbq-catering', emoji: '\u{1F356}' },
  { name: 'Burger Catering', url: '/food-truck-catering/burger-catering', emoji: '\u{1F354}' },
  { name: 'Dessert Catering', url: '/food-truck-catering/dessert-catering', emoji: '\u{1F366}' },
  { name: 'Asian Catering', url: '/food-truck-catering/asian-catering', emoji: '\u{1F961}' },
  { name: 'Breakfast Catering', url: '/food-truck-catering/breakfast-catering', emoji: '\u{1F95E}' },
];

export const CATERING_PLANNING_LINKS = [
  { name: 'Food Truck Rental', url: '/food-truck-rental' },
  { name: 'Hire a Food Truck', url: '/hire-a-food-truck' },
  { name: 'Catering Prices', url: '/food-truck-catering/prices' },
  { name: 'How It Works', url: '/catering' },
];
